import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { ToggleButtonGroup as RAC_ToggleButtonGroup } from 'react-aria-components';
import styles from './ToggleButtonGroup.module.css';
import type { ToggleButtonGroupProps } from './ToggleButtonGroup.types';
const ToggleButtonGroup = t0 => {
  const $ = _c(10);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const variant = t1 === undefined ? "default" : t1;
  const t2 = variant === "segmented";
  let t3;
  if ($[4] !== t2) {
    t3 = clsx(styles.ToggleButtonGroup, {
      [styles.segmented]: t2
    });
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== props || $[8] !== t3) {
    t4 = <RAC_ToggleButtonGroup {...props} className={t3} data-test-id="ToggleButtonGroup">{children}</RAC_ToggleButtonGroup>;
    $[6] = children;
    $[7] = props;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export { ToggleButtonGroup };